import { Alert, styled } from "@mui/material";
import { SnackbarContent } from "notistack";
import { CSSProperties } from "react";

export const StyledSnackbarContent = styled(SnackbarContent, {
  shouldForwardProp: (propName) => propName !== "alignment",
})<{
  alignment?: CSSProperties["justifyContent"];
}>`
  ${({ alignment }) => alignment && `justify-content: ${alignment}`};
`;

export const AlertIcon = styled("div")`
  display: flex;
  align-items: center;
`;

export const AlertTitle = styled("div")`
  ${(props) => props.theme.wsc.typography.body1bold}
  ::first-letter {
    text-transform: uppercase;
  }
`;

export const Message = styled("div")`
  color: ${(props) => props.theme.wsc.palette.neutral[0]};
  ${(props) => props.theme.wsc.typography.body1};
  display: flex;
  gap: ${(props) => `${props.theme.wsc.spacing[0]}`};
  > :first-child {
    ::first-letter {
      text-transform: uppercase;
    }
  }
`;

export const AssetName = styled("div")`
  white-space: nowrap;
`;

export const MessageText = styled("div")<{ allowTextOverflow?: boolean }>`
  text-overflow: ellipsis;
  ${(props) =>
    props.allowTextOverflow === true
      ? `
    word-wrap: break-word;
    height: 50%;
    `
      : `
        white-space: nowrap;
  overflow: hidden;
    `}
`;

export const ActionsContainer = styled("div")`
  display: flex;
  align-items: center;
  height: 100%;
  gap: ${(props) => `${props.theme.wsc.spacing[0]}`};
`;

export const StyledAlert = styled(Alert)`
  background-color: ${(props) => props.theme.wsc.palette.neutral[800]};
  border: 1px solid;
  border-radius: ${(props) => `${props.theme.wsc.radius.m}`};
  box-shadow: 0 8px 10px 2px rgba(0, 0, 0, 0.15);
  max-width: 40.625rem;

  ${(props) =>
    props.severity === "success" &&
    `
       color: ${props.theme.wsc.palette.success[100]};
       border-color: ${props.theme.wsc.palette.success[100]};
    `}

  ${(props) =>
    props.severity === "error" &&
    `
       color: ${props.theme.wsc.palette.warning[100]};
       border-color: ${props.theme.wsc.palette.warning[100]};
    `}

  ${(props) =>
    props.severity === "info" &&
    `
       color: ${props.theme.wsc.palette.neutral[0]} ;
       background-color: ${props.theme.wsc.palette.neutral[600]} 
       border: none;
    `}
  
  .MuiAlert-message {
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: ${(props) => props.theme.wsc.spacing[1]};
  }
`;
